'use client'

import '../../internal/styled-components.mjs';
import { css } from 'styled-components';

const get = (id) => (props) => props[id];
const color = (id) => (props) => props.theme.colors[id];
const spacing = (id) => (props) => props.theme.spacings[id];
const typography = (id) => (props) => props.theme.typography[id];
const rgba = (colorize, alpha) => (props) => {
  const hex = colorize(props);
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const elevationStyle = (id) => (props) => props.theme.elevationStyle[id];
const breakpoints = {
  up: function(size) {
    return (props) => {
      return css`only screen and (min-width: ${props.theme.breakpoints[size]})`;
    };
  },
  down: function(size) {
    return (props) => {
      return css`only screen and (max-width: ${props.theme.breakpoints[size]})`;
    };
  }
};

export { breakpoints, color, elevationStyle, get, rgba, spacing, typography };
//# sourceMappingURL=styles.mjs.map
